// When the coach is back, on this browser's clock (docs/design/CALL-POP-KRISP-BAR.md lane 2, and the COACH_DAYS
// follow-up of October 31, 2026): the time alone when the opening is within a day, which always reads as the next 7:00,
// and the full weekday too when it is more than a day away. COACH_DAYS keeps the coach closed on the weekend, so from
// Friday evening to early Sunday the opening is Monday's. The coach's status says it ("Coach is off until 7:00", "Coach
// is off until Monday 7:00") and so does the wrap-up box ("Wrap-up at 7:00", "Wrap-up Monday 7:00"), on one line each:
// "Coach is off until Monday 7:00" is 161 px in say-status, which has 172 px in the narrowest window the Chrome harness
// opens (720x600); a weekday on every weeknight, "Wednesday 7:00" included (179 px), would not fit there.

export const COACH_OPENING_DAY_MS = 86_400_000;

export interface CoachOpening {
  /** The full weekday ("Monday") when the opening is more than a day after now; null within a day. */
  day: string | null;
  /** "7:00", "13:30": 24-hour, no leading zero. */
  time: string;
}

export function coachOpening(at: number, now: number = Date.now()): CoachOpening {
  const d = new Date(at);
  const time = `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`;
  return { day: at - now > COACH_OPENING_DAY_MS ? d.toLocaleDateString('en-US', { weekday: 'long' }) : null, time };
}
